$('.test').on('click', function(){
	console.log('testicles');
});